import React from 'react';
import { useSelector } from 'react-redux';

export default function useCallCenterSelector() {
  const CallCenterData = useSelector((state) => state.CallCenter.call_center) || {}; // Call Center
  const CallViewData = useSelector((state) => state.CallCenter.call_view) || {}; // Call View Data
  const EmployementTypeData = useSelector((state) => state.CallCenter.employementType) || {}; //
  const SubEmployementTypeData = useSelector((state) => state.CallCenter.SubEmployementType) || {}; //

  return {
    CallCenterData,
    CallViewData,
    EmployementTypeData,
    SubEmployementTypeData
  };
}
